<form [formGroup]="group" autocomplete="off">
  <div class="{{ gs.isVersion2 ? '' : 'form-autocomplete' }}">

    @if (!config.isDateTime && !appearance && !config.partySize) {
      <mat-form-field class="basic-input-field " [ngClass]="config.class" appearance="outline">
        <mat-label class="select-label">{{config.label | translate}}</mat-label>
        <input matInput [ngClass]="{'adjusted-width': config.icon1}" placeholder="{{config.placeholder | translate}}"    #trigger="matAutocompleteTrigger"   [matAutocomplete]="auto" [formControlName]="config.name"  [attr.name]="config.name" (input)='filterOptions($event)' (focus)='filterOptions($event)' autocomplete="new-password" >
        <i class="search-icon {{config.icon1}} seat-icon-color" [ngClass]="{'show-icon':config.icon1 && group.controls[FormControlName].value == ''}"  (click)="iconClick($event)"></i>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" (closed)="validInput($event)" >
          <ng-scrollbar class="scroll-event">
            @for (autocompleteOption of autocompleteOptions; track autocompleteOption) {
              <mat-option [value]="autocompleteOption.value">
                <span [innerHTML]="autocompleteOption.value"></span>
              </mat-option>
            }
          </ng-scrollbar>
          <!-- <mat-option *ngIf = "!(autocompleteOptions.length > 0)">
          <span>No Data Found</span>
        </mat-option> -->
      </mat-autocomplete>
      @if (showErrorText) {
        <mat-error>
          {{'selectValue' | translate }}
        </mat-error>
      }
      @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText) {
        <mat-error>
          {{config.errorMessage | translate}}
        </mat-error>
      }
    </mat-form-field>
  }
  @if (config.addBtnConfig) {
    <app-form-add-button [addBtnConfig]="config.addBtnConfig"></app-form-add-button>
  }
</div>
@if (appearance && !config.isDateTime && !config.partySize) {
  <div class="{{ gs.isVersion2 ? '' : 'form-autocomplete' }}">
    <mat-form-field class="basic-input-field {{config.class}}" [ngClass]="{'input-with-boundary':config.appearance}" appearance="outline">
      <mat-label class="select-label">{{config.label | translate}}</mat-label>
      <input matInput placeholder="{{config.placeholder | translate}}" [matAutocomplete]="auto" [formControlName]="config.name"  [attr.name]="config.name" (input)='filterOptions($event)' (focus)='filterOptions($event)' >
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" (closed)="validInput($event)">
        <!-- <ng-scrollbar class="scroll-event"> -->
        <ng-scrollbar class="scroll-event">
          @for (autocompleteOption of autocompleteOptions; track autocompleteOption) {
            <mat-option [value]="autocompleteOption.value">
              <span [innerHTML]="autocompleteOption.value"></span>
            </mat-option>
          }
        </ng-scrollbar>
      <!-- </ng-scrollbar> -->
      <!-- <mat-option *ngIf = "!(autocompleteOptions.length > 0)">
      <span>No Data Found</span>
    </mat-option> -->
  </mat-autocomplete>
  @if (showErrorText) {
    <mat-error>
      {{'selectValue' | translate }}
    </mat-error>
  }
  </mat-form-field>
  </div>
}
@if (config.isDateTime && !appearance && !config.partySize) {
  <div class="{{ gs.isVersion2 ? '' : 'form-autocomplete' }}">
    @if (!appearance) {
      <mat-form-field class="basic-input-field " [ngClass]="config.class" appearance="outline">
        <mat-label class="select-label">{{config.label | translate}}</mat-label>
        <input matInput [ngClass]="{'adjusted-width': config.icon1}" placeholder="{{config.placeholder | translate}}" #trigger="matAutocompleteTrigger"   [matAutocomplete]="auto" [formControlName]="config.name"  [attr.name]="config.name" (input)='filterOptions($event)' (focus)='filterOptions($event)' autocomplete="off" (keypress)="omit_Characters($event)" >
        <i class="search-icon {{config.icon1}} seat-icon-color" [ngClass]="{'show-icon':config.icon1 && group.controls[FormControlName].value == ''}"  (click)="iconClick($event)"></i>
        <mat-autocomplete #auto="matAutocomplete">
          <!-- <ng-scrollbar class="scroll-event"> -->
          @for (autocompleteOption of autocompleteOptions; track autocompleteOption) {
            <mat-option (click)="dateSelection(autocompleteOption)" [value]="autocompleteOption.DateTime " [disabled]="autocompleteOption.IsDisabled">
              {{autocompleteOption.DateTime }}
            </mat-option>
          }
        <!-- </ng-scrollbar> -->
        <!-- <mat-option *ngIf = "!(autocompleteOptions.length > 0)">
        <span>No Data Found</span>
      </mat-option> -->
    </mat-autocomplete>
    @if (showErrorText) {
      <mat-error>
        {{'selectValue' | translate }}
      </mat-error>
    }
    @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText) {
      <mat-error>
        {{config.errorMessage | translate}}
      </mat-error>
    }
  </mat-form-field>
}
</div>
}

@if (config.partySize) {
  <div class="{{ gs.isVersion2 ? '' : 'form-autocomplete' }}">
    <mat-form-field class="basic-input-field " [ngClass]="config.class" appearance="outline">
      <mat-label class="select-label">{{config.label | translate}}</mat-label>
      <input matInput [ngClass]="{'adjusted-width': config.icon1}" placeholder="{{config.placeholder | translate}}" [maxlength]="config.charLength" #trigger="matAutocompleteTrigger"   [matAutocomplete]="auto" [formControlName]="config.name"  [attr.name]="config.name" (input)='filterOptions($event)' (focus)='filterOptions($event)' autocomplete="off" (keypress)="omit_Characters($event)" numbersOnly>
      <i class="search-icon {{config.icon1}} seat-icon-color" [ngClass]="{'show-icon':config.icon1 && group.controls[FormControlName].value == ''}" (click)="iconClick($event)"></i>
      <mat-autocomplete #auto="matAutocomplete" (closed)="validInput($event)" >
        <!-- <ng-scrollbar class="scroll-event"> -->
        <ng-scrollbar class="scroll-event">
          @for (autocompleteOption of autocompleteOptions; track autocompleteOption) {
            <mat-option [value]="autocompleteOption.value">
              <span [innerHTML]="autocompleteOption.value"></span>
            </mat-option>
          }
        </ng-scrollbar>
      <!-- </ng-scrollbar> -->
    </mat-autocomplete>
    @if (showErrorText) {
      <mat-error>
        {{'selectValue' | translate }}
      </mat-error>
    }
    @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText && !group.controls[FormControlName].hasError('min')) {
      <mat-error>
        {{ 'emptyPartySize' | translate}}
      </mat-error>
    }
    @if (group.controls[FormControlName].hasError('min') && group.controls[FormControlName].touched && config.showErrorText && !group.controls[FormControlName].hasError('required')) {
      <mat-error>
        {{'zeroPartySizeValidation' | translate}}
      </mat-error>
    }
  </mat-form-field>
</div>
}
</form>